import React from 'react'
import { Grid, Table, Input, Popup} from 'semantic-ui-react'
import { Button, Label, Header, Segment} from 'semantic-ui-react'
import { connect } from 'react-redux';
import { changeUserPoints } from '../reducers/actions';

class PointsControl extends React.Component {
    state = { valueAdd:0, valueSub :0, buttonDisabled : false, reason : ''}

    
    changeAdd = (evt) =>{
        this.setState({valueAdd : parseInt(evt.target.value)});
    }

    changeReason = (evt) =>{
        this.setState({reason : evt.target.value});
    }

    changeSub = (evt) =>{
        if (evt.target.value >= this.props.userPoints[this.props.user_id]) {
            this.setState({buttonDisabled : true})
        }else{
            this.setState({valueSub : parseInt(evt.target.value)});
            this.setState({buttonDisabled : false})
        }
    }

    clickAdd = () =>{
        this.props.changeUserPoints(this.props.socket,this.props.user_id, this.state.valueAdd, this.state.reason)
    }

    clickSub = () =>{
        this.props.changeUserPoints(this.props.socket,this.props.user_id, -this.state.valueSub, this.state.reason)        
    }

    render(){   
        return (<Segment>
            <div style={{ textAlign: 'center' }}>
            <Header color ='yellow'>Qui puoi togliere e aggiungere punti all'utente.</Header>
            <Table striped celled fixed>
            <tbody>
            <Table.Row >
              <Table.Cell colSpan ={2}>
                  <Grid>
                  <Grid.Row textAlign='center' style = {{display:'block', padding:'7px'}}>
                  <Label style={{fontSize: '13px'}} horizontal color='purple' size='big'>Punti attuali</Label>  
                  </Grid.Row>
                  <Grid.Row textAlign='center' style = {{display:'block', padding:'7px'}}>    
                  <Header as='h2' style={{ fontWeight: 'normal' }}>{this.props.userPoints[this.props.user_id]}</Header>
                  </Grid.Row>
                  </Grid>
              </Table.Cell>                    
            </Table.Row>
            <Table.Row >
              <Table.Cell >
                  <Grid>
                  <Grid.Row textAlign='center' style = {{display:'block', padding:'7px'}}>
                  <Input type='number' onChange= {this.changeAdd} placeholder= {'Punti da aggiungere'} inverted/>
                  </Grid.Row>
                  <Grid.Row floated='left' textAlign='center' style = {{display:'block', padding:'7px'}}>
                  <Button content='Assegna punti' onClick={this.clickAdd} color = 'green' />
                  </Grid.Row>
                  </Grid>
              </Table.Cell>
              <Table.Cell>
              <Grid>
                  <Grid.Row textAlign='center' style = {{display:'block', padding:'7px'}}>
                  <Popup content={`Min: 0 Max: ${this.props.userPoints[this.props.user_id]}`}  trigger={ 
                  <Input type='number' onChange= {this.changeSub}  placeholder= {'Punti da togliere'} inverted/>} />
                  </Grid.Row>
                  <Grid.Row floated='left' textAlign='center' style = {{display:'block', padding:'7px'}}>
                  <Button content='Togli punti' disabled = {this.state.buttonDisabled} onClick={this.clickSub} color = 'red'  negative />
                  </Grid.Row>
                  </Grid>
              </Table.Cell>                     
              </Table.Row>
              <Table.Row >
              <Table.Cell colSpan ={2}>
                  <Grid>
                  <Grid.Row textAlign='center' style = {{display:'block', padding:'7px'}}>
                  <Label style={{fontSize: '13px'}} horizontal color='purple' size='big'>Perchè:</Label>  
                  </Grid.Row>
                  <Grid.Row textAlign='center' style = {{display:'block', padding:'7px'}}>    
                  <Input onChange= {this.changeReason}  placeholder= {'Inserisci qui il motivo della modifica'} fluid inverted />
                  </Grid.Row>
                  </Grid></Table.Cell>                    
            </Table.Row>
              </tbody>
            </Table>
            </div>
          </Segment>
        )
    }
    
}


const mapStateToProps = (state) => ({    
    socket: state.socket
})
 
 const mapDispatchToProps = (dispatch) => ({
    changeUserPoints: (socket, user_id, points, reason) => dispatch(changeUserPoints(socket, user_id, points, reason))
 })
 
 
 export default connect(
     mapStateToProps,
     mapDispatchToProps
 )(PointsControl)


// WEBPACK FOOTER //
// ./src/components/PointsControl.js